import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';

// Import pages directly (no lazy loading for better SEO and pre-rendering)
import Home from './pages/Home';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import RefundPolicy from './pages/RefundPolicy';
import AndroidAppDevelopment from './pages/services/AndroidAppDevelopment';
import FlutterAppDevelopment from './pages/services/FlutterAppDevelopment';
import WebDevelopment from './pages/services/WebDevelopment';
import WordPressDevelopment from './pages/services/WordPressDevelopment';
import UIUXDesign from './pages/services/UIUXDesign';
import IOSDevelopment from './pages/services/iOSDevelopment';
import AIChatbotsSmartTools from './pages/services/AIChatbotsSmartTools';

function App() {
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Tech Update",
        "url": "https://www.gettechupdate.com"
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Tech Update",
        "url": "https://www.gettechupdate.com"
      }
    ]
  };

  return (
    <Router>
      <div className="App">
        <SEO 
          structuredData={combinedSchema}
        />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/terms-of-service" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/services/android-app-development" element={<AndroidAppDevelopment />} />
          <Route path="/services/flutter-app-development" element={<FlutterAppDevelopment />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/wordpress-development" element={<WordPressDevelopment />} />
          <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/services/ios-development" element={<IOSDevelopment />} />
          <Route path="/services/ai-chatbots-smart-tools" element={<AIChatbotsSmartTools />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

